import { Link } from "react-router-dom";

export const Logo = ({ light = false, testId = "logo-link" }) => (
  <Link to="/" data-testid={testId} aria-label="Mika Solution — Beranda" className="group inline-flex items-center">
    <img
      src={light ? "/images/logo-mika-light.png" : "/images/logo-mika.png"}
      alt="Logo Mika Solution"
      width="794"
      height="283"
      className="h-11 w-auto transition-transform duration-500 group-hover:scale-[1.03] sm:h-[52px]"
    />
  </Link>
);
